<template>
    <div
        ref="resultwrapper"
        class="quickscan-result"
    >
        <h2 class="quickscan-result__title">{{ current.header }}</h2>
        <!-- eslint-disable vue/no-v-html -->
        <div
            class="quickscan-result__description"
            v-html="current.description"
        />
        <!-- eslint-enable vue/no-v-html -->

        <div class="quickscan-result__ctas">
            <CraftLink
                v-if="current.primaryButton?.element?.uri || current.primaryButton?.url"
                :link="current.primaryButton"
                class="dn-button base-button"
            />
            <CraftLink
                v-if="current.secondaryButton?.element?.uri || current.secondaryButton?.url"
                :link="current.secondaryButton"
                class="dn-button base-button base-button--white"
            />
        </div>

        <ContentBlocksEmployee
            v-if="current?.contact?.[0]"
            v-bind="current.contact[0]"
        />
    </div>
</template>

<script setup>
defineProps({
    current: {
        type: Object,
        required: true
    }
});

const resultwrapper = ref(null);

onMounted(() => {
    resultwrapper.value.scrollIntoView(true, {
        behavior: 'smooth'
    });
});
</script>

<style lang="less" src="./Result.less" />
